
import * as angular from "angular";

export interface IWebSocketStatusPacket {
    list: IWebSocketStatus[];
}

export interface IWebSocketStatus {
    accountId: number;
    dataTypes: string[];
    created: string;
}

export class DiagnosticsService {

    static $inject = ["$http"];

    constructor(
        private $http: angular.IHttpService) {
    }

    getWebSocketStatus() {
        return this
            .$http({
                url: "/api/bifrost/websocketstatus",
                method: "GET"
            })
            .then((response: angular.IHttpPromiseCallbackArg<IWebSocketStatusPacket>) => {
                return response.data;
            });
    }
}

